import { render, staticRenderFns } from "./ProductMainMenu.vue?vue&type=template&id=0fa965f1&scoped=true"
import script from "./ProductMainMenu.vue?vue&type=script&lang=js"
export * from "./ProductMainMenu.vue?vue&type=script&lang=js"
import style0 from "./ProductMainMenu.vue?vue&type=style&index=0&id=0fa965f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa965f1",
  null
  
)

export default component.exports